import { render, staticRenderFns } from "./paymentNote.vue?vue&type=template&id=53d4b4be"
import script from "./paymentNote.vue?vue&type=script&lang=js"
export * from "./paymentNote.vue?vue&type=script&lang=js"
import style0 from "./paymentNote.vue?vue&type=style&index=0&id=53d4b4be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports